import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { apiV2 } from "api/firebase";
import { IdleManager } from "tools/idle";

type State = {
  items: Record<string, string>;
  isLoading: boolean;
};

type Action = {
  fetch: (showId: string, force?: boolean) => Promise<void>;
  update: (showId: string) => Promise<void>;
  autoCatch: (showId: string) => Promise<void>;
  getByShowId: (showId: string) => string | null;
};

export const useAspSsoLinkStore = create(
  devtools<State & Action>((set, get) => ({
    isLoading: false,
    items: {},

    getByShowId: (showId: string): string | null => {
      const { items } = get();

      if (!items?.[showId]) {
        return null;
      }

      return items[showId];
    },

    autoCatch: async (showId: string) => {
      const { update } = get();

      IdleManager.getInstance().addSubscriber(`asp-${showId}`, async () => {
        await update(showId);
      });
    },

    update: async (showId: string) => {
      const { items } = get();

      try {
        const { link } = await apiV2.asp.getSsoLink({
          showId,
        });

        set(() => ({
          items: {
            ...items,

            [showId]: link,
          },
        }));
      } catch (e) {
        console.error("asp store:", e);
      }
    },

    fetch: async (showId: string, force = false) => {
      const { isLoading, items, update } = get();

      if (!force) {
        if (items[showId] || isLoading) {
          return;
        }
      }

      set(() => ({ isLoading: true }));

      try {
        await update(showId);
      } catch (e) {
        console.error(e);
      } finally {
        set(() => ({ isLoading: false, showId }));
      }
    },
  }))
);
